// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3_Dlj","list":"BalanceDue_list__2G4qX","listRow":"BalanceDue_listRow__2GVQB","total":"BalanceDue_total__HskhL"};